const LOCK_PREFIX = 'fritidskortet-poll-'

/**
 * Acquires a Web Lock for the given Fritidskortet payment session so only one tab
 * runs the poll + confirm loop at a time. Falls back to direct invocation on browsers
 * that do not support the Web Locks API — backend idempotency is the safety net there.
 */
export async function withFritidskortetPollLock<T>(paymentSessionId: string, fn: () => Promise<T>): Promise<T> {
  if (typeof navigator !== 'undefined' && navigator.locks) {
    return navigator.locks.request(`${LOCK_PREFIX}${paymentSessionId}`, fn)
  }
  return fn()
}
